import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';
import {getDefaultExposure} from 'helpers/player-helper';

class MinAdjustedPlayersValidator extends BaseValidator {
    protected runValidation(): void {
        if (this.isMoreAdjustmentsNeeded()) {
            this.addError(
                'To Comply With Draftkings Terms, users must like, dislike, lock or set min/max exposures on at least ' +
                    Const.DRAFTKINGS_MIN_ADJUSTED_PLAYERS +
                    ' players before running an optimization.',
            );
        }
    }

    private isMoreAdjustmentsNeeded(): boolean {
        // @ts-ignore
        const {players} = this.dependencies;

        let adjustedQuantity = 0;
        for (let player of players) {
            if (this.isPlayerAdjusted(player)) {
                adjustedQuantity++;
            }

            if (Const.DRAFTKINGS_MIN_ADJUSTED_PLAYERS <= adjustedQuantity) {
                return false;
            }
        }

        return true;
    }

    private isPlayerAdjusted(player): boolean {
        return (
            this.isPlayerLocked(player) || this.isPlayerExposureChanged(player) || this.isPlayerPointsChanged(player)
        );
    }

    private isPlayerLocked(player): boolean {
        // @ts-ignore
        const {playersLock} = this.dependencies;
        return playersLock.isLockedAnywhere(player.getId());
    }

    private isPlayerExposureChanged(player): boolean {
        return this.isPlayerFlexExposureChanged(player) || this.isPlayerOverallMaxExposureChanged(player);
    }

    private isPlayerFlexExposureChanged(player): boolean {
        return (
            getDefaultExposure('min') !== Number(player.exposureMin) ||
            getDefaultExposure('max') !== Number(player.exposureMax)
        );
    }

    private isPlayerOverallMaxExposureChanged(player): boolean {
        return 'overall_exposureMax' in player && getDefaultExposure('max') !== Number(player.overall_exposureMax);
    }

    private isPlayerPointsChanged(player): boolean {
        // @ts-ignore
        const {propNameOfDefaultUserPointsValue} = this.dependencies;
        const defaultPoints = parseFloat(player[propNameOfDefaultUserPointsValue]);
        return parseFloat(player.userPoints) !== defaultPoints;
    }
}

export {MinAdjustedPlayersValidator};
